export default __webpack_public_path__ + "static/media/decentraland_bw.d9149849.svg";